import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_metronic/layout/core";
import { TopupPacksList } from "./TopupPacksList";

const breadcrumbs: Array<PageLink> = [
  {
    title: "Credit Packs Management",
    path: "/topup-packs/list",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const TopupPacksPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="list"
          element={
            <>
              <PageTitle breadcrumbs={breadcrumbs}>Credit Packs list</PageTitle>
              <TopupPacksList/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to="/topup-packs/list" />} />
    </Routes>
  );
};

export default TopupPacksPage;
